import { ChangeDetectionStrategy, Component, inject, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslatePipe } from '@ngx-translate/core';
import { DIALOG_DATA, DialogRef } from '@angular/cdk/dialog';
import { SvgIconComponent } from '@ngneat/svg-icon';
import { TeethComponent } from '@libs/perio';
import { DEFAULT_TEETH } from '@libs/ui-lib';

export interface PerioExamMissingToothModalData {
  missingTeeth: number[];
  extractedTeeth: number[];
}

export interface PerioExamMissingToothModalPayload {
  missingTeeth: number[];
}

@Component({
  selector: 'lib-perio-exam-missing-tooth-modal',
  imports: [CommonModule, TranslatePipe, SvgIconComponent, TeethComponent],
  templateUrl: './perio-exam-missing-tooth-modal.component.html',
  styleUrl: './perio-exam-missing-tooth-modal.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PerioExamMissingToothModalComponent {
  private readonly dialogRef = inject<DialogRef<PerioExamMissingToothModalPayload, PerioExamMissingToothModalData>>(DialogRef);
  private readonly dialogData = inject<PerioExamMissingToothModalData>(DIALOG_DATA);

  protected teeth = DEFAULT_TEETH;
  protected readonly extractedTeethPositions = this.dialogData.extractedTeeth;
  protected missingTeethPositions = signal<number[]>(this.dialogData.missingTeeth);

  public cancel(): void {
    this.dialogRef.close();
  }

  public saveChanges(): void {
    this.dialogRef.close({ missingTeeth: [...this.missingTeethPositions()] });
  }

  protected toothClicked(toothPosition: number): void {
    if (this.extractedTeethPositions.includes(toothPosition)) {
      return;
    }
    if (this.missingTeethPositions().includes(toothPosition)) {
      this.missingTeethPositions.update((teeth) => teeth.filter((t) => t !== toothPosition));
    } else {
      this.missingTeethPositions.update((teeth) => [...teeth, toothPosition]);
    }
  }
}
